import { StoricoModuloService } from './../services/storicomodulo.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as Enum from '../utils/enums'
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { DialogService } from 'primeng/api';
import { IDocumento } from '../interfaces/IDocumento';
import { DocumentoModalComponent } from '../documento-modal/documento-modal.component';
import { AlertUtil } from '../utils/alert-util';
import { IStoricoRisposte } from '../interfaces/IStoricoRisposte';
import { DocumentiService } from '../services/documenti.service';
import * as Constants from '../utils/constants';
import { Util } from '../utils/util';
import { DataTableComponent } from '../data-table/data-table.component';
import { SendDocumentoModalComponent } from '../send-documento-modal/send-documento-modal.component';

@Component({
  selector: 'app-variazione',
  templateUrl: './variazione.component.html',
  styleUrls: ['./variazione.component.css']
})
export class VariazioneComponent implements OnInit {

  documenti: IDocumento[] // documenti table data source
  documentoSelected: IDocumento // documento selected from table

  DTT = Enum.DATA_TABLE_TYPE_ENUM //export enum for html
  L = Loading                     //export loading for html

  isAffidatario: boolean //determines whether the user logged is affidatario 
  isAdmin: boolean //determines whether the user logged is admin 
  isAggiudicatario: boolean //determines whether the user logged is aggiudicatario 
  isEsecutore: boolean //determines whether the user logged is esecutore 

  @ViewChild("dtDocumenti") dtDocumenti: DataTableComponent

  constructor(private dialogService: DialogService,
    private documentiService: DocumentiService,
    private alertUtil: AlertUtil,
    private storicoModuloService: StoricoModuloService) { }

  ngOnInit() {
    let userRole = localStorage.getItem(Constants.LS_USER_ROLE)
    setTimeout(() => {
      this.checkUserRole(userRole)
      this.fetchListaDocumentiInVariazione()
    }, 0);

  }

  /**
  * check role of user logged
  */
  checkUserRole(userRole: string) {
    if (userRole == Enum.USER_TYPE_ENUM.AMMINISTRATORE) {
      this.isAdmin = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AFFIDATARIO
      || userRole == Enum.USER_TYPE_ENUM.GVS
      || userRole == Enum.USER_TYPE_ENUM.CSE) {
      this.isAffidatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.AGGIUDICATARIO) {
      this.isAggiudicatario = true
    } else if (userRole == Enum.USER_TYPE_ENUM.ESECUTORE) {
      this.isEsecutore = true
    }
  }

  onShowPDF(documento: IDocumento) {
    let documentoCloned: IDocumento = {
      Id: documento.Id,
      Nome: documento.Nome,
      Descrizione: documento.Descrizione,
      Tipologia: documento.Tipologia,
      Data_scadenza: documento.Data_scadenza,
      Documento: documento.Documento,
      DocumentoCreato: documento.DocumentoCreato,
      Autore: documento.Autore,
      Versione: -1
    }
    let reqBuilder = new RequestBuilder(documentoCloned)
    this.documentiService.showPDF(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(response => {
      if (response && response["error"] == null) {
        Util.showPdf(response)
      }
      else if (response.error) {
        let errorKey = "LBL_ERROR_" + response.error.Code
        this.alertUtil.showErrorAlert(errorKey)
        console.log("ERROR: " + JSON.stringify(response.error.Stack))
      }
      else {
        this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
      }
    }, error => {
      let errorKey = "LBL_HTTP_ERROR_0"
      if (error.status) {
        errorKey = "LBL_HTTP_ERROR_" + error.status
      }
      this.alertUtil.showErrorAlert(errorKey)
    })
  }


  /**
  * fetch lista documenti in variazione
  */
  fetchListaDocumentiInVariazione(callback?: any) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({})
    this.documentiService.fetchVariazioni(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          if (callback) {
            callback(response.data)
          }
          else {
            //Resets sort, filter and paginator state.
            // Modifica del 22/11/2024 - Commentato il reset della table per evitare di perdere la pagina corrente
            //this.dtDocumenti.resetTable()
            this.documenti = response.data
            // this.handleDocumentiRead()
          }
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }


  /**
   * callback fired when one documento row is selected
   * @param documento
   */
  onDocumentoRowSelected(documento: IDocumento) {
    Loading.isLoading = true
    let requestBuilder = new RequestBuilder({
      Id: documento.Id,
      Version: -1
    })
    this.storicoModuloService.storicoModuloFetchSingle(requestBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.documentoSelected = response.data
          this.createCustomResponse()
          this.openDocumentoModal(this.documentoSelected)
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
  * callback fired when one documento row is unselected
  */
  onDocumentoRowUnselected() {
    this.documentoSelected = null
  }

  /**
   * open documento modal
   * @param documento 
   */
  openDocumentoModal(documento: IDocumento) {
    let documentoModal = this.dialogService.open(DocumentoModalComponent,
      {
        data: { documento, richiesta: documento.Richiesta, fromVersioning: true },
        header: documento.Nome,
        width: '80%'
      })

    // refresh documenti when modal is closed
    documentoModal.onClose.subscribe(() => {
      this.fetchListaDocumentiInVariazione()
      this.onDocumentoRowUnselected()
    })
  }

  /**
   * read documento Selected and set Risposta Custom for all questions
   */
  createCustomResponse() {
    let storicoRisposte = this.documentoSelected.StoricoRisposte //get storico risposte array
    let matrDomande = this.documentoSelected.MatriceModulo.MatriceDomande //get matrice domande array
    if (matrDomande) {
      for (let i = 0; i < matrDomande.length; i++) { // iterate matrice domande
        let matriceDomanda = matrDomande[i]
        if (storicoRisposte) {
          for (let y = 0; y < storicoRisposte.length; y++) { // iterate storico risposte
            let storicoRisp = storicoRisposte[y]
            if (storicoRisp.Domanda_Id == matriceDomanda.Id) { // if answer for this question set rispostaCustom to matrice domanda
              matriceDomanda.RispostaCustom = storicoRisp
              break;
            }
          }
          if (!matriceDomanda.RispostaCustom) { // if matrice domanda has no risposta custom set empty risposta
            let storicoEmpty: IStoricoRisposte = {
              Domanda_Id: matriceDomanda.Id,
              Valore: null,
              Placeholder: null,
              Valido: null
            }
            matriceDomanda.RispostaCustom = storicoEmpty
          }
        }
      }
    }
  }

  /**
    * Send documento for change status
    * @param documento 
    */
  onSendDocumento(documento: IDocumento) {
    if (this.isAffidatario) {
      this.openSendDocumentoModal(documento)
    } else if (this.isAggiudicatario || this.isEsecutore) {
      if (documento.StatoModulo.Id == Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.IN_VARIAZIONE ||
        documento.StatoModulo.Id == Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.VARIAZIONE_NON_APPROVATA) {
        // send to affidatario if current StatoModulo is IN_VARIAZIONE or VARIAZIONE_NON_APPROVATA
        this.sendDocumentoToAffidatario(documento)
      }
    }
  }

  /**
     * Send documento to Affidatario
     * @param documento 
     */
  private sendDocumentoToAffidatario(documento: IDocumento) {
    this.alertUtil.showConfirmationAlert("LBL_DOCUMENTO_SEND_TO_AFFIDATARIO", null, null, null, null, () => {
      // set documento.StatoModulo to VARIAZIONE_IN_LAVORAZIONE
      documento.StatoModulo.Id = Enum.DOCUMENTO_VARIAZIONE_STATE_ENUM.VARIAZIONE_IN_LAVORAZIONE
      documento.StatoModulo.Nome = Enum.DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM.VARIAZIONE_IN_LAVORAZIONE
      // force documento.StatoModulo.Moduli as null
      documento.StatoModulo.Moduli = null

      //change status documento
      Loading.isLoading = true

      let reqBuilder = new RequestBuilder({
        Id: documento.Id,
        StatoModulo: documento.StatoModulo
      })
      this.storicoModuloService.storicoChangeStatus(reqBuilder).pipe(finalize(() => {
        Loading.isLoading = false
      })).subscribe(
        response => {
          if (response.data) {
            this.alertUtil.showAlert("LBL_DOCUMENTO_SENT_TO_AFFIDATARIO", null, null, null, () => {
              //force refresh documento table
              this.fetchListaDocumentiInVariazione()
            })
          }
          else if (response.error) {
            let errorKey = "LBL_ERROR_" + response.error.Code
            this.alertUtil.showErrorAlert(errorKey)
            if (response.error.Code == 326) {
              this.fetchListaDocumentiInVariazione()
              this.onDocumentoRowUnselected()
            }
          }
          else {
            this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
          }
        },
        error => {
          let errorKey = "LBL_HTTP_ERROR_0"
          if (error.status) {
            errorKey = "LBL_HTTP_ERROR_" + error.status
          }
          this.alertUtil.showErrorAlert(errorKey)
        }
      )
    })
  }

  /**
  * open send documento modal
  * @param documento 
  */
  openSendDocumentoModal(documento: IDocumento) {
    //open send documento modal
    let sendDocumentoModal = this.dialogService.open(SendDocumentoModalComponent, {
      data: { documento },
      header: documento.Nome,
      width: '40%'
    })

    // refresh documentiList when modal is closed 
    sendDocumentoModal.onClose.subscribe((documento: IDocumento) => {
      //force refresh 
      if (documento) {
        this.fetchListaDocumentiInVariazione()
      }
    })
  }
}